module.exports = __webpack_public_path__ + "static/img/移动APP定制.6b60fccc.png";